<template>
  <v-layout>
    <v-flex xs12>
      <v-card class="elevation-2 mx-2 mt-12">
        <v-card-title>
          <v-layout>
            <v-flex xs12>
              <v-card
                dark
                raised
                class="elevation-5 px-3 py-4 mt-n12 title font-weight-light"
                color="secondary"
                >Акции</v-card
              >
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text class="mt-2">
          <v-container v-if="this.promotions != null">
            <v-layout column>
              <v-flex
                xs12
                v-for="item in this.promotions"
                :key="item.promotionId"
              >
                <a
                  class="text-no-decoration"
                  target="_blank"
                  :href="item.link"
                  >{{ item.name }}</a
                >
                <v-divider></v-divider>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    promotions: {
      type: Array,
      required: true,
    },
  },
  computed: {},
  methods: {},
  data: () => ({}),
  mounted() {},
};
</script>
